module.exports = __webpack_public_path__ + "img/regulations-arrow.3594ad2b.svg";